window.theme = window.theme || {};
var THMHelper = window.BEYHelper || {};
THMHelper.qs = document.querySelector.bind(document);
THMHelper.qsa = document.querySelectorAll.bind(document);
THMHelper.qid = document.getElementById.bind(document);
THMHelper.qde = document.documentElement;

var Thm = {
    init: function () {
        this.Basic.init();
    },
    Basic: {
        init: function () {
            this.handleScrollForHeader();
            this.mega_menu();
            this.searchToggle();
            this.drawerToggler();
            this.HeaderSliderule();
            this.smoothScroll();
            this.marqueeScroller();
            this.slideshowSwiper();
            this.collapsibleContent();
            this.collapsibleContentMobile();
            this.tab_content()
            this.buyNowButton();
            this.sticky_header();
            this.video_media();
        },
        handleScrollForHeader: function () {
            function closeDropdowns() {
                const openTriggers = document.querySelectorAll('[aria-expanded="true"]');
                openTriggers.forEach(trigger => {
                    trigger.setAttribute('aria-expanded', 'false');
                    trigger.classList.remove('is-visible');
                });

                const openMenus = document.querySelectorAll('.is-visible');
                openMenus.forEach(menu => {
                    menu.classList.remove('is-visible');
                });

                const header = document.querySelector('[data-sticky-type="on-scroll-up"]');
                header?.classList.remove('meganav--visible');
            }
            const header = document.querySelector('[data-sticky-type="on-scroll-up"]');
            if (!header) return;

            window.addEventListener('scroll', () => {
                const rect = header.getBoundingClientRect();
                const isOutOfView = rect.bottom <= 0;
                if (isOutOfView) {
                    closeDropdowns();
                }
            });

        },
        mega_menu: function () {
            const selectors = {
                disclosureToggle: 'data-hover-disclosure-toggle',
                disclosureWrapper: '[data-hover-disclosure]',
                link: '[data-top-link]',
                wrapper: '[data-header-wrapper]',
                stagger: '[data-stagger]',
                staggerPair: '[data-stagger-first]',
                staggerAfter: '[data-stagger-second]',
                staggerImage: '[data-grid-item], [data-header-image]'
            };
            const classes = {
                isVisible: 'is-visible',
                meganavVisible: 'meganav--visible',
                grandparent: 'grandparent'
            };

            class HoverDisclosure {
                constructor(el) {
                    this.disclosure = el;
                    this.wrapper = el.closest(selectors.wrapper);
                    this.key = this.disclosure.id;
                    this.trigger = document.querySelector(`[${selectors.disclosureToggle}='${this.key}']`);
                    this.link = this.trigger.querySelector(selectors.link);
                    this.grandparent = this.trigger.classList.contains(classes.grandparent);

                    this.trigger.setAttribute('aria-haspopup', true);
                    this.trigger.setAttribute('aria-expanded', false);
                    this.trigger.setAttribute('aria-controls', this.key);

                    this.initEvents();
                    this.staggerChildAnimations();
                }

                initEvents() {
                    this.trigger.addEventListener('pointerenter', () => this.show());
                    this.trigger.addEventListener('pointerleave', () => this.hide());
                    this.link.addEventListener('focus', () => this.show());
                    this.trigger.addEventListener('focusout', (e) => {
                        if (!this.trigger.contains(e.relatedTarget)) this.hide();
                    });
                    this.disclosure.addEventListener('keyup', (e) => {
                        if (e.code === 'Escape') this.hide();
                    });
                    this.trigger.addEventListener('touchstart', (e) => {
                        if (!this.disclosure.classList.contains(classes.isVisible)) {
                            e.preventDefault();
                            this.show();
                        }
                    }, { passive: true });
                }

                show() {
                    if (this.grandparent) {
                        this.wrapper.classList.add(classes.meganavVisible);
                    } else {
                        this.wrapper.classList.remove(classes.meganavVisible);
                    }
                    this.trigger.classList.add(classes.isVisible);
                    this.disclosure.classList.add(classes.isVisible);
                    this.trigger.setAttribute('aria-expanded', true);
                }

                hide() {
                    this.wrapper.classList.remove(classes.meganavVisible);
                    this.trigger.classList.remove(classes.isVisible);
                    this.disclosure.classList.remove(classes.isVisible);
                    this.trigger.setAttribute('aria-expanded', false);
                }

                staggerChildAnimations() {
                    this.disclosure.querySelectorAll(selectors.stagger).forEach((el, i) => {
                        el.style.transitionDelay = `${i * 50 + 10}ms`;
                    });
                    this.disclosure.querySelectorAll(selectors.staggerPair).forEach((el, i) => {
                        const d1 = i * 150;
                        el.style.transitionDelay = `${d1}ms`;
                        el.parentElement.querySelectorAll(selectors.staggerAfter).forEach((child, j) => {
                            child.style.transitionDelay = `${d1 + (j + 1) * 20}ms`;
                        });
                    });
                    this.disclosure.querySelectorAll(selectors.staggerImage).forEach((el, i) => {
                        el.style.transitionDelay = `${(i + 1) * 80}ms`;
                    });
                }
            }

            document.querySelectorAll(selectors.disclosureWrapper).forEach(el => {
                new HoverDisclosure(el);
            });
        },
        searchToggle: function () {
            // Search toggle button
            const toggleBtn = document.querySelector('[data-popdown-toggle]');
            if (!toggleBtn) return;

            // ID from data attribute
            const popdownId = toggleBtn.getAttribute('data-popdown-toggle');
            const popdown = document.getElementById(popdownId);
            const underlay = document.querySelector('[data-search-underlay]');
            const closeBtn = document.querySelector('.search-popdown__close-button');

            function openPopdown() {
                if (popdown)
                    popdown.classList.add('is-visible');
                if (underlay) underlay.classList.add('underlay--visible');
                document.body.style.overflow = 'hidden';
            }

            function closePopdown() {
                if (popdown) popdown.classList.remove('is-visible');
                if (underlay) underlay.classList.remove('underlay--visible');
                document.body.style.overflow = '';
            }

            // Toggle button click
            toggleBtn.addEventListener('click', function (e) {
                e.preventDefault();
                if (popdown.classList.contains('is-visible')) {
                    closePopdown();
                } else {
                    openPopdown();
                }
            });

            // Underlay click
            if (underlay) {
                underlay.addEventListener('click', closePopdown);
            }

            // Close button click
            if (closeBtn) {
                closeBtn.addEventListener('click', closePopdown);
            }
        },
        drawerToggler: function () {
            const drawerToggleButtons = document.querySelectorAll('[data-drawer-toggle]');
            const body = document.body;

            drawerToggleButtons.forEach(button => {
                button.addEventListener('click', () => {
                    const drawerTarget = button.getAttribute('data-drawer-toggle');
                    const drawer = document.querySelector(`[data-drawer="${drawerTarget}"]`);

                    if (!drawer) return;

                    const isOpen = drawer.classList.contains('drawer--visible');

                    if (!isOpen) {
                        openDrawer(drawer);
                    } else {
                        closeDrawer(drawer);
                    }
                });
            });

            // Close button
            const drawerCloseButtons = document.querySelectorAll('.drawer__close_button');
            drawerCloseButtons.forEach(button => {
                button.addEventListener('click', () => {
                    const drawer = button.closest('[data-drawer]');
                    closeDrawer(drawer);
                });
            });

            // Underlay click
            const drawerUnderlays = document.querySelectorAll('[data-drawer-underlay]');
            drawerUnderlays.forEach(underlay => {
                underlay.addEventListener('click', () => {
                    const drawer = underlay.closest('[data-drawer]');
                    closeDrawer(drawer);
                });
            });

            function openDrawer(drawer) {
                drawer.classList.add('drawer--visible');

                body.classList.add('drawer-open'); // for body overflow hidden
                body.style.overflow = 'hidden';
            }

            function closeDrawer(drawer) {
                drawer.classList.remove('drawer--visible');

                body.classList.remove('drawer-open');
                body.style.overflow = '';
            }
        },
        HeaderSliderule: function () {

            class HeaderSlideruleComponent extends HTMLElement {
                connectedCallback() {
                    const selectors = {
                        drawer: 'data-drawer-scrolls',
                        slideruleOpen: 'data-sliderule-open',
                        slideruleClose: 'data-sliderule-close',
                        sliderulePane: 'data-sliderule-pane',
                        slideruleWrappper: '[data-sliderule]',
                        dataAnimates: 'data-animates',
                        children: `:scope > [data-animates],
                                        :scope > * > [data-animates],
                                        :scope > * > * >[data-animates],
                                        :scope .sliderule-grid  > *`
                    };

                    const classes = {
                        isVisible: 'is-visible',
                        isHiding: 'is-hiding',
                        isHidden: 'is-hidden'
                    };

                    class HeaderMobileSliderule {
                        constructor(el) {
                            this.sliderule = el;
                            this.wrapper = el.closest(selectors.slideruleWrappper);
                            this.key = this.sliderule.id;
                            this.trigger = document.querySelector(`[${selectors.slideruleOpen}="${this.key}"]`);
                            this.exit = document.querySelectorAll(`[${selectors.slideruleClose}="${this.key}"]`);
                            this.drawer = document.querySelector(`[${selectors.drawer}]`);
                            this.pane = document.querySelector(`[${selectors.sliderulePane}]`);
                            this.children = this.sliderule.querySelectorAll(selectors.children);

                            this.trigger.setAttribute('aria-haspopup', true);
                            this.trigger.setAttribute('aria-expanded', false);
                            this.trigger.setAttribute('aria-controls', this.key);

                            this.clickEvents();
                            this.keyboardEvents();
                            this.staggerChildAnimations();

                            // document.addEventListener('theme:sliderule:close', this.closeSliderule.bind(this));
                        }

                        clickEvents() {
                            this.trigger.addEventListener('click', () => this.showSliderule());
                            this.exit.forEach((el) => {
                                el.addEventListener('click', () => this.hideSliderule());
                            });
                        }

                        keyboardEvents() {
                            this.trigger.addEventListener('keyup', (evt) => {
                                if (evt.code === 'Space') this.showSliderule();
                            });
                            this.sliderule.addEventListener('keyup', (evt) => {
                                if (evt.code === 'Escape') {
                                    this.hideSliderule();
                                    this.trigger.focus();
                                }
                            });
                        }

                        staggerChildAnimations(reverse = false) {
                            const childrenArr = reverse
                                ? Array.from(this.children).slice().reverse()
                                : this.children;
                            childrenArr.forEach((child, index) => {
                                child.style.transitionDelay = index * 50 + 10 + 'ms';
                            });
                        }

                        hideSliderule(close = false) {
                            const paneStyle = window.getComputedStyle(this.pane);
                            const duration = parseFloat(paneStyle.getPropertyValue('transition-duration')) * 1000;
                            const children = close ? this.pane.querySelectorAll(`.${classes.isVisible}`) : this.children;

                            this.pane.style.setProperty('--sliderule-height', 'auto');
                            this.staggerChildAnimations(true);

                            this.pane.classList.add(classes.isHiding);
                            this.sliderule.classList.add(classes.isHiding);
                            this.sliderule.classList.remove(classes.isVisible);
                            children.forEach((el) => el.classList.remove(classes.isVisible));

                            const newPosition = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                            this.pane.setAttribute(selectors.sliderulePane, newPosition);

                            const hidedSelector = close
                                ? `[${selectors.dataAnimates}].${classes.isHidden}`
                                : `[${selectors.dataAnimates}="${newPosition}"].${classes.isHidden}`;
                            const hidedItems = this.pane.querySelectorAll(hidedSelector);
                            hidedItems.forEach((el) => el.classList.remove(classes.isHidden));

                            setTimeout(() => {
                                this.pane.classList.remove(classes.isHiding);
                                this.sliderule.classList.remove(classes.isHiding);
                                this.staggerChildAnimations();
                            }, duration);
                        }

                        showSliderule() {
                            const oldPosition = parseInt(this.pane.dataset.sliderulePane, 10);
                            const newPosition = oldPosition + 1;
                            this.pane.setAttribute(selectors.sliderulePane, newPosition);

                            this.pane.style.setProperty('--sliderule-height', 'auto');
                            this.sliderule.classList.add(classes.isVisible);
                            this.children.forEach((el) => el.classList.add(classes.isVisible));

                            const hidedItems = this.pane.querySelectorAll(`[${selectors.dataAnimates}="${oldPosition}"]`);
                            if (hidedItems.length) {
                                const hideDelay = parseFloat(
                                    window.getComputedStyle(hidedItems[0]).getPropertyValue('transition-duration')
                                ) * 1000;
                                setTimeout(() => {
                                    hidedItems.forEach((el) => el.classList.add(classes.isHidden));
                                }, hideDelay);
                            }

                            const newHeight = this.trigger.nextElementSibling.offsetHeight;
                            this.pane.style.setProperty('--sliderule-height', `${newHeight}px`);

                            const drawerScrollY = this.drawer.scrollTop;
                            const scrollToElement = this.pane.offsetTop;
                            const enableScrollTo =
                                scrollToElement < drawerScrollY && this.pane.offsetHeight >= this.drawer.offsetHeight;
                            if (enableScrollTo) {
                                this.drawer.scrollTo({
                                    top: scrollToElement,
                                    behavior: 'smooth'
                                });
                            }
                        }

                        closeSliderule() {
                            if (
                                this.pane &&
                                this.pane.hasAttribute(selectors.sliderulePane) &&
                                parseInt(this.pane.getAttribute(selectors.sliderulePane)) > 0
                            ) {
                                this.hideSliderule(true);
                                this.pane.setAttribute(selectors.sliderulePane, 0);
                            }
                        }
                    }

                    // auto init
                    document.querySelectorAll(selectors.slideruleWrappper).forEach((el) => {
                        new HeaderMobileSliderule(el);
                    });
                }
            }
            // register component
            customElements.define('header-sliderule', HeaderSlideruleComponent);
        },
        video_media: function () {


            class THMLazyLoadingVideo extends HTMLElement {
                constructor() {
                    super();
                    this.isLoaded = false; // internal flag
                }

                loadVideo() {
                    if (this.isLoaded) return; // prevent duplicate loading
                    this.isLoaded = true;

                    if (this.dataVideoType === "local_video") {
                        const videoElement = this.querySelector("video");
                        const sourceElement = videoElement?.querySelector("source");
                        const videoSrc = sourceElement?.getAttribute("data-src");

                        if (videoSrc) {
                            sourceElement.setAttribute("src", videoSrc);
                            videoElement.load();
                            videoElement.muted = true;

                            videoElement.addEventListener("canplay", () => {
                                videoElement.play().catch(err => {
                                    console.warn("Autoplay failed:", err);
                                });
                            });
                        } else {
                            console.warn("Missing data-src on local video source.");
                        }
                    } else if (this.dataVideoType === "youtube" || this.dataVideoType === "vimeo") {
                        const iframe = this.querySelector("iframe");
                        const iframeSrc = iframe?.getAttribute("data-src");

                        if (iframe && iframeSrc) {
                            iframe.setAttribute("src", iframeSrc);
                        } else {
                            console.warn("Missing data-src on iframe.");
                        }
                    }
                }

                execute() {
                    if (Shopify.designMode) {
                        this.loadVideo();
                    } else {
                        const loadOnce = () => this.loadVideo();

                        ['mousemove', 'touchstart', 'scroll', 'click'].forEach(event => {
                            window.addEventListener(event, loadOnce, { once: true });
                        });

                        // fallback: load anyway after 3 seconds if user does nothing
                        setTimeout(() => {
                            this.loadVideo();
                        }, 10);
                    }
                }

                static get observedAttributes() {
                    return ["data-video-type", "data-video-id"];
                }

                set dataVideoType(val) {
                    this.setAttribute("data-video-type", val);
                }
                get dataVideoType() {
                    return this.getAttribute("data-video-type");
                }

                set dataVideoId(val) {
                    this.setAttribute("data-video-id", val);
                }
                get dataVideoId() {
                    return this.getAttribute("data-video-id");
                }

                attributeChangedCallback(name, oldValue, newValue) {
                    if (oldValue !== newValue) {
                        this.execute();
                    }
                }

                connectedCallback() {
                    this.execute();
                }

                disconnectedCallback() {
                    // optional: clean up if you had dynamic event listeners, but since we used { once: true }, nothing to clean
                }
            }

            customElements.define("thm-load-video", THMLazyLoadingVideo);



            class THMLoadMedia extends HTMLElement {
                constructor() {
                    super(),
                        (this.$ = this.querySelector.bind(this)),
                        (this.sectionID = this.dataset.sectionId),
                        (this.idVideo = this.dataset.idVideo),
                        (this.typeVideo = this.dataset.type),
                        (this.eleVideo = `shtVideo-${this.sectionID}-` + this.idVideo),
                        (this.onPlayerStateYTChange = this.onPlayerStateYTChange.bind(this)),
                        (this.onPlayerPlay = this.onPlayerPlay.bind(this)),
                        (this.playPauseButton = this.$(".video-play-pause-button")),
                        (this.trigger = this.$(".js-load-media-trigger")),
                        this.trigger && this.trigger.addEventListener("click", this.handlePlayVideo.bind(this));

                    if (this.playPauseButton) {
                        this.playPauseButton.addEventListener("click", this.togglePlayPauseVideo.bind(this));
                    }
                }


                togglePlayPauseVideo() {
                    this.classList.add("playing");
                    this.loadContent();

                    const video = this.$(".js-media-item-video");

                    if (!video) return;

                    // First time play: pause others, play this
                    if (video.paused || video.ended) {
                        this.pauseAllVideo(video);
                        video.play();
                        this.updatePlayPauseIcon(true);
                    } else {
                        video.pause();
                        this.updatePlayPauseIcon(false);
                    }

                    // ✅ If YouTube player is present
                    if (this.player && typeof this.player.getPlayerState === "function") {
                        const state = this.player.getPlayerState();
                        if (state === YT.PlayerState.PAUSED || state === YT.PlayerState.ENDED) {
                            this.pauseAllVideo(this.player);
                            this.player.playVideo();
                            this.updatePlayPauseIcon(true);
                        } else if (state === YT.PlayerState.PLAYING) {
                            this.player.pauseVideo();
                            this.updatePlayPauseIcon(false);
                        }
                    }



                }

                updatePlayPauseIcon(isPlaying) {
                    const playIcon = this.playPauseButton?.querySelector(".video-play-icon");
                    const pauseIcon = this.playPauseButton?.querySelector(".video-pause-icon");

                    if (!playIcon || !pauseIcon) return;

                    if (isPlaying) {
                        playIcon.style.display = "none";
                        pauseIcon.style.display = "inline";
                    } else {
                        playIcon.style.display = "inline";
                        pauseIcon.style.display = "none";
                    }
                }



                handlePlayVideo() {
                    this.classList.add("playing");
                    this.loadContent();
                    const t = this.querySelector(".js-media-item-video");
                    t &&
                        t.addEventListener("play", () => {
                            this.pauseAllVideo(t), t.play();
                        });
                }
                onYouTubeIframeAPIReady() {
                    if ("undefined" != typeof YT && void 0 !== YT.Player)
                        try {
                            this.player = new YT.Player(this.eleVideo, {
                                videoId: this.idVideo,
                                playerVars: { playsinline: 1 },
                                events: {
                                    onReady: this.onPlayerYTReady,
                                    onStateChange: this.onPlayerStateYTChange,
                                },
                            });
                        } catch (t) {
                            console.error("Lỗi khi tạo trình phát YouTube:", t);
                        }
                    else {
                        var t = document.createElement("script"),
                            e =
                                ((t.src = "https://www.youtube.com/iframe_api"),
                                    (t.onload = () => {
                                        this.onYouTubeIframeAPIReady();
                                    }),
                                    document.getElementsByTagName("script")[0]);
                        e.parentNode.insertBefore(t, e);
                    }
                }
                onVimeoIframeAPIReady() {
                    if ("undefined" != typeof Vimeo && void 0 !== Vimeo.Player)
                        try {
                            var t = { id: this.idVideo, autoplay: 1 };
                            (this.playerVimeo = new Vimeo.Player(this.eleVideo, t)),
                                this.playerVimeo.on("play", () => {
                                    this.pauseAllVideo(this.playerVimeo);
                                });
                        } catch (t) {
                            console.error("Lỗi khi tạo trình phát Vimeo:", t);
                        }
                    else {
                        var t = document.createElement("script"),
                            e =
                                ((t.src = "https://player.vimeo.com/api/player.js"),
                                    (t.onload = () => {
                                        this.onVimeoIframeAPIReady();
                                    }),
                                    document.getElementsByTagName("script")[0]);
                        e.parentNode.insertBefore(t, e);
                    }
                }
                onPlayerYTReady = () => {
                    this.pauseAllVideo(this.player), this.player.playVideo();
                };
                // onPlayerStateYTChange = (t) => {
                //   1 == t.data && this.onPlayerPlay();
                // };

                onPlayerStateYTChange = (t) => {
                    const state = t.data;

                    if (state === YT.PlayerState.PLAYING) {
                        this.onPlayerPlay(); // pause other videos
                        this.updatePlayPauseIcon(true); // 👈 show pause icon
                    } else if (
                        state === YT.PlayerState.PAUSED ||
                        state === YT.PlayerState.ENDED
                    ) {
                        this.updatePlayPauseIcon(false); // 👈 show play icon
                    }
                };



                onPlayerPlay = () => {
                    this.pauseAllVideo(this.player);
                };
                loadContent() {
                    if (!this.getAttribute("loaded")) {
                        if (this.$("template")) {
                            var t = this.$("template").content.firstElementChild.cloneNode(!0);
                            this.appendChild(t),
                                this.isLoaded(!0),
                                this.trigger && this.trigger.remove();

                            // 🔽 ADD HERE AFTER APPENDING VIDEO
                            const video = this.$(".js-media-item-video");
                            if (video && !video.hasAttribute("data-listeners-added")) {
                                video.addEventListener("play", () => this.updatePlayPauseIcon(true));
                                video.addEventListener("pause", () => this.updatePlayPauseIcon(false));
                                video.addEventListener("ended", () => this.updatePlayPauseIcon(false));
                                video.setAttribute("data-listeners-added", "true");
                            }

                        } else {
                            if ("youtube" == this.typeVideo) this.onYouTubeIframeAPIReady();
                            else {
                                if ("vimeo" != this.typeVideo) return !0;
                                this.onVimeoIframeAPIReady();
                            }
                            this.trigger?.classList.add("d-none"),
                                this.$(".js-media-item").classList.add("d-flex");

                            // 🔽 ALSO ADD HERE in case video is not loaded via <template>
                            const video = this.$(".js-media-item-video");
                            if (video && !video.hasAttribute("data-listeners-added")) {
                                video.addEventListener("play", () => this.updatePlayPauseIcon(true));
                                video.addEventListener("pause", () => this.updatePlayPauseIcon(false));
                                video.addEventListener("ended", () => this.updatePlayPauseIcon(false));
                                video.setAttribute("data-listeners-added", "true");
                            }

                        }
                        return !0;
                    }
                }
                pauseAllVideo(e) {
                    THMHelper.qsa(
                        ".js-product-media-deferred-video:has([data-type='youtube']"
                    ).forEach((t) => {
                        t.player && e !== t.player && t.player?.pauseVideo();
                    }),
                        THMHelper.qsa(
                            ".js-product-media-deferred-video:has([data-type='vimeo'])"
                        ).forEach((t) => {
                            t.playerVimeo !== e && t.playerVimeo?.pause();
                        }),
                        THMHelper.qsa(".js-media-item-video").forEach((t) => {
                            t !== e && t.pause();
                        });
                }
                isLoaded(t) {
                    t ? this.setAttribute("loaded", !0) : this.removeAttribute("loaded");
                }
            }
            customElements.define("thm-load-media", THMLoadMedia);




        },
        tab_content: function () {
            if (!customElements.get('tabbed-content')) {
                class Tabs extends HTMLElement {
                    constructor() {
                        super();
                        this.tabList = this.querySelector('[role="tablist"]');
                        this.activeTab = this.tabList.querySelector('[aria-selected="true"]');
                        this.isVerticalTablist = this.tabList.getAttribute('aria-orientation') === 'vertical';
                        this.tabs = this.querySelectorAll('[role="tab"]');
                        this.panels = this.querySelectorAll('[role="tabpanel"]');

                        // If no tab is active by default, activate the first tab.
                        if (!this.activeTab) {
                            this.activeTab = this.tabs[0];
                            this.activateTab(this.activeTab);
                        }

                        this.addListeners();
                    }

                    addListeners() {
                        this.tabList.addEventListener('click', this.handleClick.bind(this));
                        this.tabList.addEventListener('keydown', this.handleKeydown.bind(this));
                    }

                    handleClick(evt) {
                        if (!evt.target.matches('[role="tab"]') || evt.target === this.activeTab) return;
                        this.activateTab(evt.target);

                    }

                    handleKeydown(evt) {
                        switch (evt.key) {
                            case 'ArrowLeft':
                            case 'ArrowRight':
                                evt.preventDefault();
                                if (!this.isVerticalTablist) {
                                    this.switchTabOnKeyPress(evt.key);
                                }
                                break;

                            case 'ArrowUp':
                            case 'ArrowDown':
                                evt.preventDefault();
                                if (this.isVerticalTablist) {
                                    this.switchTabOnKeyPress(evt.key);
                                }
                                break;

                            case 'Home':
                                evt.preventDefault();
                                this.activateTab(this.tabs[0]);
                                break;

                            case 'End':
                                evt.preventDefault();
                                this.activateTab(this.tabs[this.tabs.length - 1]);
                                break;
                        }
                    }

                    switchTabOnKeyPress(key) {
                        if (key === 'ArrowRight' || key === 'ArrowDown') {
                            if (this.activeTab === this.tabs[this.tabs.length - 1]) {
                                this.activateTab(this.tabs[0]);
                            } else {
                                this.activateTab(this.activeTab.nextElementSibling);
                            }
                        } else if (key === 'ArrowLeft' || key === 'ArrowUp') {
                            if (this.activeTab === this.tabs[0]) {
                                this.activateTab(this.tabs[this.tabs.length - 1]);
                            } else {
                                this.activateTab(this.activeTab.previousElementSibling);
                            }
                        }
                    }

                    activateTab(tab) {
                        this.deactivateActiveTab();

                        Tabs.setTabState(tab, true);
                        tab.removeAttribute('tabindex');
                        this.activeTab = tab;

                        const panelId = tab.getAttribute('aria-controls');
                        const panel = document.getElementById(panelId);

                        if (panel) {
                            panel.classList.add('fade-in');  // Add animation class

                            setTimeout(() => {
                                panel.classList.remove('fade-in');
                            }, 500);
                        }

                        if (document.activeElement.matches('.tablist__tab')) {
                            tab.focus();
                        }
                    }

                    deactivateActiveTab() {
                        Tabs.setTabState(this.activeTab, false);
                        this.activeTab.setAttribute('tabindex', '-1');
                        this.activeTab = null;
                    }

                    static setTabState(tab, active) {
                        tab.setAttribute('aria-selected', active);

                        const panelId = tab.getAttribute('aria-controls');
                        const panel = document.getElementById(panelId);

                        if (panel) {
                            if (active) {
                                panel.hidden = false;
                            } else {
                                panel.hidden = true;
                            }
                        }
                    }

                }

                customElements.define('tabbed-content', Tabs);
            }
        },
        sticky_header: function () {
            var header = document.querySelector('[data-sticky-type="always"]');

            if (header != null) {
                onScroll = () => {
                    var scrolledPage = Math.round(window.pageYOffset);
                    if (scrolledPage > 80) {
                        header.classList.add('sticky');
                    } else {
                        header.classList.remove('sticky');
                    }
                }
                document.addEventListener('scroll', onScroll);
            }
        },
        smoothScroll: function () {

            
            document.querySelectorAll('a[href*="#"]:not([href="#"]):not([href="#0"]):not([href="#recover"]):not([href="#login"])').forEach(a => {
                a.addEventListener('click', function (e) {
                    if (location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') && location.hostname === this.hostname) {
                        var target = document.querySelector(this.hash) || document.querySelector('[name=' + this.hash.slice(1) + ']');
                        if (target) {
                            e.preventDefault();
                            window.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
                            setTimeout(() => {
                                target.focus();
                                if (!target.matches(':focus')) {
                                    target.setAttribute('tabindex', '-1');
                                    target.focus();
                                }
                            }, 600);
                        }
                    }
                });
            });

        },
        marqueeScroller: function () {
            if (!customElements.get("marquee-content")) {
                class Marquee extends HTMLElement {
                    constructor() {
                        super();
                    }
                    connectedCallback() {
                        this.init();
                    }
                    calculationPaddingSection() {
                        (this.heightSection = this.offsetHeight),
                            (this.heightSection =
                                this.heightSection < 18
                                    ? 18
                                    : 96 < this.heightSection
                                        ? 96
                                        : this.heightSection),
                            this.closest(".js-running-content").style.setProperty(
                                "--spacing-padding-block",
                                this.heightSection + "px"
                            );
                    }
                    init() {
                        (this.distance =
                            this.querySelector(".js-marquee-item").offsetWidth),
                            (this.speed = this.dataset.speed),
                            this.style.setProperty(
                                "--marquee-duration",
                                this.distance / this.speed + "s"
                            );
                    }
                }
                customElements.define("marquee-content", Marquee);
            }
        },
        slideshowSwiper: function () {

            class slideshowSwiper extends HTMLElement {
                constructor() {
                    super();
                    this.swiper = null;
                }

                initSlider() {
                    if (this.swiper) {
                        this.swiper.destroy(true, true); // Destroy old instance before re-init
                    }

                    this.sliderWrapper = this.querySelector(".slideshow__swiper");

                    let centered_slides = this.sliderWrapper.dataset.centeredslides !== undefined
                        ? JSON.parse(this.sliderWrapper.dataset.centeredslides)
                        : undefined;
                    let effect_fade = this.sliderWrapper.dataset.effectfade !== undefined
                        ? JSON.parse(this.sliderWrapper.dataset.effectfade)
                        : undefined;
                    let pagination_type = this.sliderWrapper.dataset.paginationtype !== undefined
                        ? this.sliderWrapper.dataset.paginationtype
                        : "bullets";

                    let next = this.querySelector(".swiper-button-next");
                    let prev = this.querySelector(".swiper-button-prev");
                    let pagination = this.querySelector(".swiper-pagination");
                    let scroll = this.querySelector(".swiper-scrollbar");

                    this.swiper = new Swiper(this.sliderWrapper, {
                        effect: effect_fade ? "fade" : "slide",
                        centeredSlides: centered_slides || false,
                        slidesPerView: parseInt(this.sliderWrapper.dataset.slidesmobile),
                        spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
                        grabCursor: false,
                        horizontal: true,
                        watchSlidesProgress: true,
                        draggable: true,
                        autoHeight: false,
                        watchOverflow: true,
                        threshold: 10,
                        freeMode: JSON.parse(this.sliderWrapper.dataset.freemode),
                        loop: JSON.parse(this.sliderWrapper.dataset.loop),
                        speed: 700,
                        mousewheel: {
                            forceToAxis: true,
                        },
                        autoplay: {
                            enabled: JSON.parse(this.sliderWrapper.dataset.autoplay),
                            disableOnInteraction: false,
                            delay: parseInt(this.sliderWrapper.dataset.delay),
                        },
                        navigation: {
                            nextEl: next,
                            prevEl: prev,
                        },
                        pagination: {
                            el: pagination,
                            clickable: true,
                            type: pagination_type,
                        },
                        scrollbar: {
                            el: scroll,
                            draggable: true,
                        },
                        breakpoints: {
                            359: {
                                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesmobile),
                                spaceBetween: parseInt(this.sliderWrapper.dataset.mobilespace),
                            },
                            768: {
                                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidestab),
                                spaceBetween: parseInt(this.sliderWrapper.dataset.tabspace),
                            },
                            1024: {
                                slidesPerView: parseFloat(this.sliderWrapper.dataset.slidesdesktop),
                                spaceBetween: parseInt(this.sliderWrapper.dataset.desktopspace),
                            },
                        },
                        observer: true,
                        observeParents: true,
                    });
                }

                connectedCallback() {
                    this.initSlider();

                    // Update slider when all resources load
                    window.addEventListener('load', () => {
                        if (this.swiper) this.swiper.update();
                    });

                    // Re-init slider when section reloads in the customizer
                    document.addEventListener('shopify:section:load', () => {
                        this.initSlider();
                    });

                    // When a block (slide) is selected or added in the customizer
                    document.addEventListener('shopify:block:select', (event) => {
                        if (!this.swiper) return;

                        const blockEl = event.target; // Selected block element
                        const slide = blockEl.closest('.swiper-slide');
                        if (slide) {
                            const index = [...slide.parentElement.children].indexOf(slide);
                            if (index >= 0) {
                                this.swiper.slideToLoop(index); // Jump to that slide
                            }
                        }
                    });
                }
            }
            customElements.define("slideshow-swiper", slideshowSwiper);
        },
        collapsibleContent: function () {
            if (!customElements.get("collapsible-content")) {
                class collapsibleContent extends HTMLElement {
                    constructor() {
                        super();
                        this.disclosure = this.querySelector('details');
                        this.toggle = this.querySelector('summary');
                        this.panel = this.toggle.nextElementSibling;
                        this.init();
                    }

                    init() {
                        // Check if the content element has a CSS transition.
                        if (window.getComputedStyle(this.panel).transitionDuration !== '0s') {
                            this.toggle.addEventListener('click', this.handleToggle.bind(this));
                            this.disclosure.addEventListener('transitionend', this.handleTransitionEnd.bind(this));
                        }
                    }

                    /**
                     * Handles 'click' events on the summary element.
                     * @param {object} evt - Event object.
                     */
                    handleToggle(evt) {
                        evt.preventDefault();

                        if (!this.disclosure.open) {
                            this.open();
                        } else {
                            this.close();
                        }
                    }

                    /**
                     * Handles 'transitionend' events on the details element.
                     * @param {object} evt - Event object.
                     */
                    handleTransitionEnd(evt) {
                        if (evt.target !== this.panel) return;

                        if (this.disclosure.classList.contains('is-closing')) {
                            this.disclosure.classList.remove('is-closing');
                            this.disclosure.open = false;
                        }

                        this.panel.removeAttribute('style');
                    }

                    /**
                     * Adds inline 'height' style to the content element, to trigger open transition.
                     */
                    addContentHeight() {
                        this.panel.style.height = `${this.panel.scrollHeight}px`;
                    }

                    /**
                     * Opens the details element.
                     */
                    open() {
                        // Set content 'height' to zero before opening the details element.
                        this.panel.style.height = '0';

                        // Open the details element
                        this.disclosure.open = true;

                        // Set content 'height' to its scroll height, to enable CSS transition.
                        this.addContentHeight();
                    }

                    /**
                     * Closes the details element.
                     */
                    close() {
                        // Set content height to its scroll height, to enable transition to zero.
                        this.addContentHeight();

                        // Add class to enable styling of content or toggle icon before or during close transition.
                        this.disclosure.classList.add('is-closing');

                        // Set content height to zero to trigger the transition.
                        // Slight delay required to allow scroll height to be applied before changing to '0'.
                        setTimeout(() => {
                            this.panel.style.height = '0';
                        });
                    }
                }
                customElements.define('collapsible-content', collapsibleContent);
            }
        },
        collapsibleContentMobile: function () {


            if (!customElements.get("collapsible-mobilecontent")) {
                class CollapsibleMobileContent extends HTMLElement {
                    constructor() {
                        super();
                        this.detailsList = Array.from(this.querySelectorAll('details'));
                        this.isMobile = window.innerWidth < 768;

                        this.boundHandleResize = this.handleResize.bind(this);
                        this.boundToggleHandlers = new Map();

                        this.init();
                        window.addEventListener('resize', this.boundHandleResize);
                    }

                    init() {
                        if (this.isMobile) {
                            this.enableAccordion();
                        } else {
                            this.disableAccordion();
                        }
                    }

                    handleResize() {
                        const nowMobile = window.innerWidth < 768;
                        if (nowMobile !== this.isMobile) {
                            this.isMobile = nowMobile;
                            if (this.isMobile) {
                                this.enableAccordion();
                            } else {
                                this.disableAccordion();
                            }
                        }
                    }

                    enableAccordion() {
                        this.detailsList.forEach(details => {
                            const toggle = details.querySelector('summary');
                            const panel = toggle.nextElementSibling;

                            // Reset for mobile mode
                            panel.style.height = '0';
                            details.open = false;
                            details.classList.remove('is-closing');

                            // Create click handler for this details
                            const handler = (evt) => {
                                evt.preventDefault();
                                if (!details.open) {
                                    // Opening animation
                                    panel.style.height = '0';
                                    details.open = true;
                                    requestAnimationFrame(() => {
                                        panel.style.height = `${panel.scrollHeight}px`;
                                    });
                                } else {
                                    // Closing animation
                                    panel.style.height = `${panel.scrollHeight}px`;
                                    details.classList.add('is-closing');
                                    setTimeout(() => {
                                        panel.style.height = '0';
                                    }, 10);
                                }
                            };

                            if (!this.boundToggleHandlers.has(details)) {
                                toggle.addEventListener('click', handler);
                                this.boundToggleHandlers.set(details, handler);

                                // Transition end cleanup
                                panel.addEventListener('transitionend', (evt) => {
                                    if (evt.target !== panel) return;
                                    if (details.classList.contains('is-closing')) {
                                        details.classList.remove('is-closing');
                                        details.open = false;
                                        panel.style.height = '';
                                    }
                                });
                            }
                        });
                    }

                    disableAccordion() {
                        this.detailsList.forEach(details => {
                            const toggle = details.querySelector('summary');
                            const panel = toggle.nextElementSibling;

                            // Remove click handlers if present
                            const handler = this.boundToggleHandlers.get(details);
                            if (handler) {
                                toggle.removeEventListener('click', handler);
                                this.boundToggleHandlers.delete(details);
                            }

                            // Reset styles for desktop view
                            panel.style.height = '';
                            details.classList.remove('is-closing');
                            details.open = true;
                        });
                    }

                    disconnectedCallback() {
                        window.removeEventListener('resize', this.boundHandleResize);
                        this.detailsList.forEach(details => {
                            const toggle = details.querySelector('summary');
                            const handler = this.boundToggleHandlers.get(details);
                            if (handler) {
                                toggle.removeEventListener('click', handler);
                            }
                        });
                        this.boundToggleHandlers.clear();
                    }
                }

                customElements.define('collapsible-mobilecontent', CollapsibleMobileContent);
            }




        },
        buyNowButton: function () {
            class ShopifyBuyNowHandler {
                constructor() {
                    this.initials();
                }

                initials() {
                    document.querySelectorAll('.buy-now-js').forEach((button) => {
                        button.addEventListener('click', (e) => this.handleClick(e, button));
                    });
                }

                handleClick(e, button) {
                    e.preventDefault();

                    const form = button.closest('form');
                    if (!form) return;

                    button.classList.add('loading');
                    const spinner = button.querySelector('.loading__spinner_cricle');
                    if (spinner) spinner.classList.remove('hidden');

                    const formData = new FormData(form);
                    const url = '/cart/add.js';

                    fetch(url, {
                        method: 'POST',
                        body: formData, // Shopify expects FormData, not JSON
                    })
                        .then((response) => {
                            if (!response.ok) throw new Error('Failed to add item');
                            return response.json();
                        })
                        .then(() => {
                            button.classList.remove('loading');
                            if (spinner) spinner.classList.add('hidden');
                            window.location.href = '/checkout'; // Direct call instead of this.redirectToCheckout()
                        })
                        .catch((error) => {
                            console.error('Error adding to cart:', error);
                            button.classList.remove('loading');
                            if (spinner) spinner.classList.add('hidden');
                        });
                }
            }
            // Initialize Immediately
            new ShopifyBuyNowHandler();


        }
    },
};


document.addEventListener('DOMContentLoaded', function () {
    Thm.init();
});


// selectors
const selectors = {
    wrapper: '[data-swapper-wrapper]',
    target: '[data-swapper-target]',
    hover: 'data-swapper-hover'
};

// Swapper class
class Swapper {
    constructor(container) {
        this.container = container;
        this.target = this.container.querySelector(selectors.target);
        this.hovers = this.container.querySelectorAll(`[${selectors.hover}]`);
        this.defaultContent = this.target ? this.target.innerHTML : '';

        if (this.target && this.hovers.length) {
            this.init();
        }
    }

    init() {
        this.hovers.forEach(hover => {
            const hoverContent = hover.getAttribute(selectors.hover);

            hover.addEventListener('mouseenter', () => {
                this.target.innerHTML = hoverContent;
            });

            hover.addEventListener('mouseleave', () => {
                this.target.innerHTML = this.defaultContent;
            });

            hover.addEventListener('click', () => {
                this.defaultContent = hoverContent;
                this.target.innerHTML = hoverContent;
            });
        });
    }
}

// initialize swappers on page
function initSwappers() {
    const swapperContainers = document.querySelectorAll(selectors.wrapper);
    swapperContainers.forEach(container => {
        new Swapper(container);
    });
}

// run on page load
document.addEventListener('DOMContentLoaded', initSwappers);




document.addEventListener('DOMContentLoaded', function () {
    const paySecured = document.getElementById('pay_secured');
    const popup = document.getElementById('paymenticons');
    const closeBtn = document.getElementById('close');

    if (paySecured != null && closeBtn != null) {
        paySecured.addEventListener('click', function () {
            popup.classList.add('fade-in');
        });

        closeBtn.addEventListener('click', function () {
            popup.classList.remove('fade-in');
        });


    }




});


function TopOffset(el) {
    let rect = el.getBoundingClientRect(),
        scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return { top: rect.top + scrollTop };
}

class Stickybar extends HTMLElement {
    constructor() {
        super();
        this.sticky_close = this.querySelector(".sticky-product__close");
        this.sticky_close.addEventListener("click", this.closeSticky.bind(this));
    }
    connectedCallback() {
        this.initSticky();
    }

    closeSticky() {
        this.remove();
    }
    initSticky() {
        const productForm = document.querySelector(".product-form"),
            productStickyWrapper = document.querySelector(".sticky-product");
        window.addEventListener("scroll", function () {
            let productFormTopffset = TopOffset(productForm).top;
            window.scrollY > productFormTopffset
                ? (productStickyWrapper.classList.add("sticky_bar"),
                    document.body.classList.add("sticky__cart"))
                : (productStickyWrapper.classList.remove("sticky_bar"),
                    document.body.classList.remove("sticky__cart"));
        });
    }
}
customElements.define("sticky-component", Stickybar);




document.addEventListener('DOMContentLoaded', function () {
    const menuItems = document.querySelectorAll('.category-menu__item');
    const productGrid = document.getElementById('ProductGridContainer');
    const hero_slider = document.querySelector('.hero-slider');

    if (productGrid != null) {
        menuItems.forEach(item => {
            item.addEventListener('click', function (e) {
                e.preventDefault(); // Stop default link behavior

                const url = this.getAttribute('href');

                fetch(url)
                    .then(response => response.text())
                    .then(html => {
                        const parser = new DOMParser();
                        const doc = parser.parseFromString(html, 'text/html');

                        // Adjust this selector based on your site's structure
                        const new_hero_slider = doc.querySelector('.hero-slider');
                        const newProducts = doc.querySelector('#ProductGridContainer');

                        if (hero_slider) {
                            hero_slider.innerHTML = new_hero_slider.innerHTML;
                        }

                        if (newProducts) {
                            productGrid.innerHTML = newProducts.innerHTML;
                        }

                        // Update active class
                        document.querySelectorAll('.category-menu__item').forEach(link => {
                            link.classList.remove('category-menu__item--active');
                        });
                        this.classList.add('category-menu__item--active');

                        // Optionally update browser URL
                        window.history.pushState({}, '', url);
                    })
                    .catch(error => {
                        console.error('Error loading collection:', error);
                    });
            });
        });
    }

});






class ImageSlider extends HTMLElement {
    connectedCallback() {
        const swiperEl = this.querySelector('.product-card-slider');
        if (swiperEl) {
            new Swiper(swiperEl, {
                loop: true,
                slidesPerView: 1,
                spaceBetween: 10,
                allowTouchMove: false,
                navigation: {
                    nextEl: this.querySelector('.swiper-button-next-prof'),
                    prevEl: this.querySelector('.swiper-button-prev-prof'),
                },
                breakpoints: {
                    359: {
                      allowTouchMove: false,
                    },
                    768: {
                             allowTouchMove: true,
                          autoplay: {
                            enabled: false,
                            disableOnInteraction: false,
                            delay: 3000
                            }
                    }
                },
            });
        }
    }
}

customElements.define('image-slider', ImageSlider);



class ColorSwatch extends HTMLElement {
  constructor() {
    super();
    this.option = this.querySelector(".color-swatch__radio");
    this.variantId = this.option.dataset.variantId;
    this.variantFeaturedMedia = this.option.dataset.variantFeaturedMedia;
    this.productHandle = this.option.dataset.productHandle;
    this.productCard = this.option.closest(".product-card-wrapper");
    this.form = this.productCard.querySelector(".form");
    this.option.addEventListener("change", this.onSwatchChange.bind(this));
  }

  onSwatchChange() {
    let url = `${window.shopUrl}/products/${this.productHandle}?variant=${this.variantId}&view=colorswatch`;

    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
 
     if (this.form) {
        const idInput = this.form.querySelector('input[name="id"]');
        if (idInput) idInput.value = this.variantId;
      }
        this.updatePrice(html);
        this.updateMedia(html, this.variantFeaturedMedia);
        this.cardBadge(html);
      })
      .catch((e) => {
        console.error(e);
      });
  }


  updateMedia(html, mediaId) {
  if (!mediaId) return;

  const destination = this.productCard.querySelector(".product-media img:first-child");
  if (destination && html) {
    let active_slide = html.querySelector(`.product__media-slide[data-media-id="${this.variantFeaturedMedia}"]`);
    if (!active_slide) active_slide = html.querySelector('.product__media-slide');
    if (active_slide) {
      const sourceImg = active_slide.querySelector('img');
      if (sourceImg) {
        destination.src = sourceImg.src;
        destination.srcset = sourceImg.srcset;
      }
    }
  }


  const swiperEl = this.productCard.querySelector('.product-card-slider') || document.querySelector('.swiper');
  const hasSwiper = swiperEl && swiperEl.swiper;
  if (!swiperEl) return;
  let targetIndex = -1;
  let targetSlide = null;

  const slides = swiperEl.querySelectorAll('.swiper-slide');
  slides.forEach((slide, index) => {
    if (slide.dataset.mediaId === mediaId) {
      targetIndex = index;
      targetSlide = slide;
    }
  });

  // Update selected class
  slides.forEach(slide => slide.classList.remove('selected'));
  if (targetSlide) targetSlide.classList.add('selected');

  if (hasSwiper && targetIndex >= 0) {
    swiperEl.swiper.slideTo(targetIndex, 300);
  } else if (targetSlide) {
    targetSlide.scrollIntoView({ behavior: 'smooth', block: 'center' });
  } else {
    console.warn('[updateMedia] No matching slide found for mediaId:', mediaId);
  }
}

  updatePrice(html) {
    const destination = this.productCard.querySelector(".price");
    const source = html.querySelector(".price");
    if (source && destination) destination.innerHTML = source.innerHTML;
  }
  cardBadge(html) {
    const destination = this.productCard.querySelector(".card__badge");
    const source = html.querySelector(".card__badge");
    if (source && destination) destination.innerHTML = source.innerHTML;
  }


}
customElements.define("color-swatch", ColorSwatch);





class LookModal extends HTMLElement {
  constructor() {
    super();
    this.hotspots = null;
    this.modal = null;
    this.pagination = null;
    this.closeBtn = null;
    this.lookSlider = null;
    this.activeIndex = 0;
    this.isMobile = false;
  }

  connectedCallback() {
    this.hotspots = this.querySelectorAll('.look__dot__holder');
    this.modal = this.querySelector('.look-flex__inner--product');
    this.pagination = this.querySelector(".swiper-pagination");
    this.closeBtn = this.querySelector('.look__holder__close');

    if (!this.modal || !this.hotspots.length) {
      console.warn('LookModalSlider: Required elements not found inside component');
      return;
    }

    // // ---- Call update once on init ----
    this.updateIsMobile();

    // // ---- Bind resize ----
    window.addEventListener('resize', () => this.updateIsMobile());

    // // ---- Init Swiper ----
    this.lookSlider = new Swiper(this.querySelector('.look__slider'), {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      pagination: {
        el: this.pagination,
        clickable: true,
        renderBullet: (index, className) =>
          `<span class="${className}">${index + 1}</span>`,
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
    });

    if(!this.isMobile){
        this.modal.classList.add('is-expanded');
        this.hotspots[this.activeIndex].classList.add('is-active');
        this.lookSlider.slideToLoop ? this.lookSlider.slideToLoop(this.activeIndex, 0, false) : this.lookSlider.slideTo(this.activeIndex + this.lookSlider.loopedSlides, 0, false);
    }


    // ---- Hotspot click ----

    this.hotspots.forEach(hotspot => {
      hotspot.addEventListener('click', () => {
        const index = parseInt(hotspot.dataset.index, 10);

        if (hotspot.classList.contains('is-active')) {
          this.closeModal();
        } else {
          this.hotspots.forEach(h => h.classList.remove('is-active'));
          hotspot.classList.add('is-active');
          this.activeIndex = index;
          this.modal.classList.add('is-expanded');
          this.lookSlider.slideToLoop ? this.lookSlider.slideToLoop(index, 500) : this.lookSlider.slideTo(index, 500);
        }
      });
    });

    // ---- Close button ----
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', () => this.closeModal());
    }
  }

  updateIsMobile() {
    if (!this.modal) return; 

    const prevMobile = this.isMobile;
    this.isMobile = window.innerWidth <= 768;

    // ---- Desktop → Mobile ----
    if (!prevMobile && this.isMobile) {
      this.modal.classList.remove('is-expanded');
      this.hotspots.forEach(h => h.classList.remove('is-active'));
      this.activeIndex = 0;
    }

    // ---- Mobile → Desktop ----
    if (prevMobile && !this.isMobile) {
      const anyActive = Array.from(this.hotspots).some(h => h.classList.contains('is-active'));
      if (!anyActive) {
        this.hotspots[0].classList.add('is-active');
        this.modal.classList.add('is-expanded');
        this.activeIndex = 0;
        this.lookSlider.slideToLoop
          ? this.lookSlider.slideToLoop(this.activeIndex, 0, false)
          : this.lookSlider.slideTo(this.activeIndex + this.lookSlider.loopedSlides, 0, false);
      }
    }
  }

  closeModal() {
    this.modal.classList.remove('is-expanded');
    this.hotspots.forEach(h => h.classList.remove('is-active'));
    this.activeIndex = 0;
    this.lookSlider.slideToLoop
      ? this.lookSlider.slideToLoop(this.activeIndex, 500) // smooth back
      : this.lookSlider.slideTo(this.activeIndex, 500);
  }
}

customElements.define('look-modal', LookModal);

let getSiblings = function (elem) {
  const siblings = [];
  let sibling = elem.parentNode.firstChild;
  for (; sibling; )
    sibling.nodeType === 1 && sibling !== elem && siblings.push(sibling),
      (sibling = sibling.nextSibling);
  return siblings;
};








// class gridButtons extends HTMLElement {
//   constructor() {
//     super();
//     this.girColumnWrapper = document.querySelector("#ProductGridContainer");
//     this.productGridEl = document.querySelector(".product-grid");
//     this.gridColumnButtons = this.querySelectorAll(".gird__column_icon");
//   }

//   connectedCallback() {
//     if (this.gridColumnButtons.length) {
//       this.productGrid();
//     }
//   }

//   productGrid() {
//     let gridClassName = localStorage.getItem("gridColumn") || "grid-col-3"; // default 3 column
//     this.applyGrid(gridClassName);

//     this.gridColumnButtons.forEach((singleItem) => {
//       singleItem.addEventListener("click", () => {
//         this.gridColumnButtons.forEach((btn) => btn.classList.remove("active"));
//         singleItem.classList.add("active");

//         if (singleItem.classList.contains("product_col_two")) {
//           this.applyGrid("grid-col-2");
//         } else if (singleItem.classList.contains("product_col_three")) {
//           this.applyGrid("grid-col-3");
//         } else if (singleItem.classList.contains("product_col_four")) {
//           this.applyGrid("grid-col-4");
//         }
//       });
//     });
//   }

//   applyGrid(gridClassName) {
//     // save localStorage
//     localStorage.setItem("gridColumn", gridClassName);

//     // remove old classes
//     this.girColumnWrapper.classList.remove(
//       "grid-col-1",
//       "grid-col-2",
//       "grid-col-3",
//       "grid-col-4",
//       "grid-col-5"
//     );
//     this.girColumnWrapper.classList.add(gridClassName);

//     // css var update
//     let colNumber = 3;
//     if (gridClassName === "grid-col-2") colNumber = 2;
//     if (gridClassName === "grid-col-4") colNumber = 4;

//     if (this.productGridEl) {
//       this.productGridEl.style.setProperty("--product-list-items-per-row", colNumber);
//     }

//     // button active state ঠিক করা
//     this.gridColumnButtons.forEach((btn) => {
//       btn.classList.remove("active");
//       if (
//         (gridClassName === "grid-col-2" && btn.classList.contains("product_col_two")) ||
//         (gridClassName === "grid-col-3" && btn.classList.contains("product_col_three")) ||
//         (gridClassName === "grid-col-4" && btn.classList.contains("product_col_four"))
//       ) {
//         btn.classList.add("active");
//       }
//     });
//   }
// }

// customElements.define("grid-buttons", gridButtons);





class gridButtons extends HTMLElement {
  constructor() {
    super();
    this.girColumnWrapper = document.querySelector("#ProductGridContainer");
    this.productGridEl = document.querySelector(".product-grid");
    this.gridColumnButtons = this.querySelectorAll(".gird__column_icon");   // desktop
    this.mobileGridButtons = this.querySelectorAll(".mgird__column_icon"); // mobile
  }

  connectedCallback() {
    if (this.gridColumnButtons.length || this.mobileGridButtons.length) {
      this.productGrid();
      window.addEventListener("resize", () => this.productGrid()); // resize এ handle
    }
  }

  productGrid() {
    let isMobile = window.innerWidth <= 991;

    // localStorage থেকে নেওয়া
    let gridClassName = isMobile
      ? localStorage.getItem("gridColumnMobile") || "mgrid-col-2"
      : localStorage.getItem("gridColumnDesktop") || "grid-col-3";

    this.applyGrid(gridClassName, isMobile);

    // desktop buttons
    this.gridColumnButtons.forEach((singleItem) => {
      singleItem.onclick = () => {
        if (singleItem.classList.contains("product_col_two")) {
          this.applyGrid("grid-col-2", false);
        } else if (singleItem.classList.contains("product_col_three")) {
          this.applyGrid("grid-col-3", false);
        } else if (singleItem.classList.contains("product_col_four")) {
          this.applyGrid("grid-col-4", false);
        }
      };
    });

    // mobile buttons
    this.mobileGridButtons.forEach((singleItem) => {
      singleItem.onclick = () => {
        if (singleItem.classList.contains("mproduct_col_one")) {
          this.applyGrid("mgrid-col-1", true);
        } else if (singleItem.classList.contains("mproduct_col_two")) {
          this.applyGrid("mgrid-col-2", true);
        }
      };
    });
  }

  applyGrid(gridClassName, isMobile) {
    // save আলাদা key তে
    if (isMobile) {
      localStorage.setItem("gridColumnMobile", gridClassName);
    } else {
      localStorage.setItem("gridColumnDesktop", gridClassName);
    }

    // remove old classes
    this.girColumnWrapper.classList.remove(
      "grid-col-1",
      "grid-col-2",
      "grid-col-3",
      "grid-col-4",
      "grid-col-5",
      "mgrid-col-1",
      "mgrid-col-2"
    );
    this.girColumnWrapper.classList.add(gridClassName);

    // css var update
    let colNumber = 3;
    if (gridClassName === "grid-col-2") colNumber = 2;
    if (gridClassName === "grid-col-4") colNumber = 4;
    if (gridClassName === "mgrid-col-1") colNumber = 1;
    if (gridClassName === "mgrid-col-2") colNumber = 2;

    if (this.productGridEl) {
      this.productGridEl.style.setProperty("--product-list-items-per-row", colNumber);
    }

    // button active state update
    this.gridColumnButtons.forEach((btn) => {
      btn.classList.remove("active");
      if (
        (gridClassName === "grid-col-2" && btn.classList.contains("product_col_two")) ||
        (gridClassName === "grid-col-3" && btn.classList.contains("product_col_three")) ||
        (gridClassName === "grid-col-4" && btn.classList.contains("product_col_four"))
      ) {
        btn.classList.add("active");
      }
    });

    this.mobileGridButtons.forEach((btn) => {
      btn.classList.remove("active");
      if (
        (gridClassName === "mgrid-col-1" && btn.classList.contains("mproduct_col_one")) ||
        (gridClassName === "mgrid-col-2" && btn.classList.contains("mproduct_col_two"))
      ) {
        btn.classList.add("active");
      }
    });
  }
}

customElements.define("grid-buttons", gridButtons);




class FilterSort extends HTMLElement {
  constructor() {
    super();
    this.toggleBtn = null;
    this.list = null;
    this.hiddenSelect = null;
    this.closeBtn = null;
  }

  connectedCallback() {
    this.toggleBtn = this.querySelector(".filter-sort__toggle");
    this.list = this.querySelector(".filter-sort__list");
    this.hiddenSelect = this.closest("form")?.querySelector("select[name='sort_by']");
    this.closeBtn = this.querySelector(".dialog-close-button");

    if (!this.toggleBtn || !this.list || !this.hiddenSelect) return;

    this.bindEvents();
  }

  bindEvents() {
    if (this.dataset.bound === "true") return;
    this.dataset.bound = "true";

    // Toggle dropdown
    this.toggleBtn.addEventListener("click", (e) => {
      e.preventDefault();
      const expanded = this.toggleBtn.getAttribute("aria-expanded") === "true";
      this.toggleBtn.setAttribute("aria-expanded", !expanded);
      this.list.classList.toggle("is-open", !expanded);
    });

    // Close button
    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", (e) => {
        e.preventDefault();
        this.closeDropdown();
      });
    }

    // Click option
    this.list.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", (e) => {
        e.preventDefault();

        const value = link.dataset.value;
        this.hiddenSelect.value = value;

        // Update button label (preserve caret)
        const caret = this.toggleBtn.querySelector(".caret");
        this.toggleBtn.innerHTML = link.textContent + caret.outerHTML;

        // Close dropdown
        this.closeDropdown();

        // Trigger Shopify FacetFiltersForm reload
        this.hiddenSelect.dispatchEvent(new Event("input", { bubbles: true }));
      });
    });

    // Close when clicking outside
    document.addEventListener("click", (e) => {
      if (!this.contains(e.target)) {
        this.closeDropdown();
      }
    });
  }

  closeDropdown() {
    this.toggleBtn.setAttribute("aria-expanded", false);
    this.list.classList.remove("is-open");
  }
}

customElements.define("filter-sort", FilterSort);






// class ComplementaryProducts extends HTMLElement {
//   observer = undefined;

//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     if (Shopify.designMode) {
//       // Customiser mode e always load
//       this.loadRecommendations(this.dataset.productId);
//     } else {
//       // Live site e observer diye
//       this.initializeRecommendations(this.dataset.productId);

//       // Fallback: jodi observer fire na kore
//       setTimeout(() => {
//         if (!this.classList.contains('complementary-products--loaded')) {
//           this.loadRecommendations(this.dataset.productId);
//         }
//       }, 2500);
//     }
//   }

//   initializeRecommendations(productId) {
//     this.observer?.unobserve(this);
//     this.observer = new IntersectionObserver(
//       (entries, observer) => {
//         if (!entries[0].isIntersecting) return;
//         observer.unobserve(this);
//         this.loadRecommendations(productId);
//       },
//       { rootMargin: '0px 0px 300px 0px' } // kom margin use korsi
//     );
//     this.observer.observe(this);
//   }

//   loadRecommendations(productId) {
//     fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
//       .then((response) => response.text())
//       .then((text) => {
//         const html = document.createElement('div');
//         html.innerHTML = text;

//         const recommendations = html.querySelector('complementary-products');

//         if (recommendations?.innerHTML.trim().length) {
//           this.innerHTML = recommendations.innerHTML;
//         }

//         if (!this.querySelector('.complementary-item')) {
//           this.remove();
//           return;
//         }

//         this.classList.add('complementary-products--loaded');
//         this.addTotalAndButton();
//       })
//       .catch((e) => console.error(e));
//   }

//   addTotalAndButton() {
//     const items = this.querySelectorAll('.complementary-item');
//     if (!items.length) return;

//     let total = 0;
//     items.forEach(item => {
//       total += parseInt(item.dataset.productPrice || "0");
//     });

//     const formattedTotal = new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: '{{ shop.currency }}'
//     }).format(total / 100);

//     const totalDiv = document.createElement('div');
//     totalDiv.className = "complementary-total";
//     totalDiv.innerHTML = `<strong>Total: ${formattedTotal}</strong>`;

//     this.appendChild(totalDiv);
//   }
// }

// customElements.define('complementary-products', ComplementaryProducts);




// class ComplementaryProducts extends HTMLElement {
//   observer = undefined;

//   constructor() {
//     super();
//   }

//   connectedCallback() {
//     if (Shopify.designMode) {
//       // Customiser mode e always load
//       this.loadRecommendations(this.dataset.productId);
//     } else {
//       // Live site e observer diye
//       this.initializeRecommendations(this.dataset.productId);

//       // Fallback: jodi observer fire na kore
//       setTimeout(() => {
//         if (!this.classList.contains('complementary-products--loaded')) {
//           this.loadRecommendations(this.dataset.productId);
//         }
//       }, 2500);
//     }
//   }

//   initializeRecommendations(productId) {
//     this.observer?.unobserve(this);
//     this.observer = new IntersectionObserver(
//       (entries, observer) => {
//         if (!entries[0].isIntersecting) return;
//         observer.unobserve(this);
//         this.loadRecommendations(productId);
//       },
//       { rootMargin: '0px 0px 300px 0px' }
//     );
//     this.observer.observe(this);
//   }

//   loadRecommendations(productId) {
//     fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
//       .then((response) => response.text())
//       .then((text) => {
//         const html = document.createElement('div');
//         html.innerHTML = text;

//         const recommendations = html.querySelector('complementary-products');

//         if (recommendations?.innerHTML.trim().length) {
//           this.innerHTML = recommendations.innerHTML;
//         }

//         if (!this.querySelector('.complementary-item')) {
//           this.remove();
//           return;
//         }

//         this.classList.add('complementary-products--loaded');

//         // Add total (no button)
//         this.addTotal();
//       })
//       .catch((e) => console.error(e));
//   }

//   addTotal() {
//     const items = this.querySelectorAll('.complementary-item');
//     if (!items.length) return;

//     let total = 0;
//     items.forEach(item => {
//       total += parseInt(item.dataset.productPrice || "0");
//     });

//     // get currency from data attribute (safe)
//     const currency = this.dataset.currency || "USD";

//     const formattedTotal = new Intl.NumberFormat('en-US', {
//       style: 'currency',
//       currency: currency
//     }).format(total / 100); // Shopify prices are in cents

//     const totalDiv = document.createElement('div');
//     totalDiv.className = "complementary-total";
//     totalDiv.innerHTML = `<strong>Total: ${formattedTotal}</strong>`;

//     this.appendChild(totalDiv);
//   }
// }

// customElements.define('complementary-products', ComplementaryProducts);




// document.addEventListener('change', (e) => {
//   // check if the changed element is a comp-size-selector
//   if (!e.target.classList.contains('comp-size-selector')) return;

//   const select = e.target;
//   const selectedVariantId = select.value;

//   // find the closest wrapper (you can customize the selector as per your HTML)
//   const wrapper = select.closest('.complementary-item') || select.closest('.option-size');
//   if (!wrapper) return;

//   // find the hidden input inside this wrapper
//   const hiddenInput = wrapper.querySelector('.product-variant-id');
//   if (hiddenInput) {
//     hiddenInput.value = selectedVariantId;
//     console.log('Updated hidden input value to variant id:', selectedVariantId);
//   }
// });



class ComplementaryProducts extends HTMLElement {
  observer = undefined;

  constructor() {
    super();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      // Customiser mode e always load
      this.loadRecommendations(this.dataset.productId);
    } else {
      // Live site e observer
      this.initializeRecommendations(this.dataset.productId);

      // Fallback: jodi observer fire na kore
      setTimeout(() => {
        if (!this.classList.contains('complementary-products--loaded')) {
          this.loadRecommendations(this.dataset.productId);
        }
      }, 2500);
    }

    // Listen for variant dropdown changes
    this.initVariantListeners();
  }

  initializeRecommendations(productId) {
    this.observer?.unobserve(this);
    this.observer = new IntersectionObserver(
      (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        this.loadRecommendations(productId);
      },
      { rootMargin: '0px 0px 300px 0px' }
    );
    this.observer.observe(this);
  }

  loadRecommendations(productId) {
    fetch(`${this.dataset.url}&product_id=${productId}&section_id=${this.dataset.sectionId}`)
      .then((res) => res.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;

        const recommendations = html.querySelector('complementary-products');
        if (recommendations?.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
        }

        if (!this.querySelector('.complementary-item')) {
          this.remove();
          return;
        }

        this.classList.add('complementary-products--loaded');

        // Initial total
        this.updateTotal();
      })
      .catch((e) => console.error(e));
  }

  initVariantListeners() {
    this.addEventListener('change', (e) => {
      if (!e.target.classList.contains('comp-size-selector')) return;

      const select = e.target;
      const wrapper = select.closest('.complementary-item');
      if (!wrapper) return;

      const productJSON = wrapper.querySelector('.complementary-product-selection');
      if (!productJSON) return;

      const product = JSON.parse(productJSON.textContent);
      const selectedVariant = product.variants.find(v => v.id == select.value);
      if (!selectedVariant) return;

      // Update hidden input
      const hiddenInput = wrapper.querySelector('.product-variant-id');
      if (hiddenInput) hiddenInput.value = selectedVariant.id;

      // Update price
      const priceEl = wrapper.querySelector('.comp-item-price');
      if (priceEl) {
        if (selectedVariant.compare_at_price && selectedVariant.compare_at_price > selectedVariant.price) {
          priceEl.innerHTML = `
            <span class="orginal-price">${(selectedVariant.price / 100).toLocaleString('en-US', { style: 'currency', currency: this.dataset.currency || 'USD' })}</span>
            <span class="sale-price">${(selectedVariant.compare_at_price / 100).toLocaleString('en-US', { style: 'currency', currency: this.dataset.currency || 'USD' })}</span>
          `;
        } else {
          priceEl.innerHTML = `
            <span class="orginal-price">${(selectedVariant.price / 100).toLocaleString('en-US', { style: 'currency', currency: this.dataset.currency || 'USD' })}</span>
          `;
        }
      }

      // Update total
      this.updateTotal();
    });
  }

updateTotal() {
  const items = this.querySelectorAll('.complementary-item');
  let total = 0;

  items.forEach(wrapper => {
    const productJSON = wrapper.querySelector('.complementary-product-selection');
    if (!productJSON) return;

    const product = JSON.parse(productJSON.textContent);
    const hiddenInput = wrapper.querySelector('.product-variant-id');
    if (!hiddenInput) return;

    const selectedVariant = product.variants.find(v => v.id == hiddenInput.value);
    if (!selectedVariant) return;

    total += selectedVariant.price;
  });

  // Display total
  let totalEl = this.querySelector('.complementary-total');
  if (!totalEl) {
    totalEl = document.createElement('div');
    totalEl.className = 'complementary-total';
    totalEl.innerHTML = `
      <span>Total:</span>
      <span></span>
    `;
    this.appendChild(totalEl);
  }

  // Update only the second <span> with formatted price
  const currency = this.dataset.currency || 'USD';
  const formattedTotal = (total / 100).toLocaleString('en-US', { style: 'currency', currency: currency });
  totalEl.querySelectorAll('span')[1].textContent = formattedTotal;
}

}

customElements.define('complementary-products', ComplementaryProducts);




class RecentlyViewed extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.productHandle = this.getAttribute('data-product-handle');
    this.sectionId = this.getAttribute('data-section-id');
    this.limit = this.getAttribute('data-limit');

    new IntersectionObserver(this.#handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px'
    }).observe(this);
  }

  #handleIntersection = (entries, observer) => {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);
    this.#fetchProducts();
  };

  /**
   * Get handles and filter current product.
   *
   * @returns {String} handles
   */
  #getHandles() {
    const handlesString = localStorage.getItem('recently-viewed');
    if (!handlesString) {
      this.classList.add('hidden');
      return;
    }

    const handlesArr = handlesString.split(',');
    const handles = this.productHandle
      ? handlesArr.filter(handle => handle !== this.productHandle)
      : handlesArr;

    if (handles.length === 0) {
      this.classList.add('hidden');
      return;
    }

    return handles.join(',');
  }

  #fetchProducts() {
    const handles = this.#getHandles();

    if (!handles) return;

    fetch(
      `${window.location.pathname}?sections=${this.sectionId}&handles=${handles}&limit=${this.limit}`
    )
      .then(response => response.json())
      .then(data => {
        const parser = new DOMParser();
        const html = parser.parseFromString(
          data[this.sectionId],
          'text/html'
        );
        const recent = html.querySelector('recently-viewed');
        if (recent && recent.innerHTML.trim().length) {
          this.innerHTML = recent.innerHTML;
        }
      })
      .catch(e => {
        console.error(e);
      });
  }
}

customElements.define('recently-viewed', RecentlyViewed);





class NewsletterModal extends HTMLElement {
    constructor() {
        super();
    }
    connectedCallback() {
        window.location.pathname !== "/challenge" && (this.popup = this.querySelector(".newsletter-modal__content"), this.closePopup = this.querySelectorAll(".newsletter-modal--toggle, .newsletter-modal-overlay"), this.hidePopup = this.querySelector(".newsletter-modal--hide"), this.cookieName = "newsletter-modal", this.closePopup.forEach(item => {
            item.addEventListener("click", this.close.bind(this))
        }), this.hidePopup?.addEventListener("click", this.hide.bind(this)), (!this.getCookie(this.cookieName) || this.dataset.mode === "test") && this.init(), 
        Shopify.designMode && (
              document.addEventListener("shopify:section:load", event => editorShopifyEvent(event, this, () => this.open.bind(this))),
             document.addEventListener("shopify:section:select", event => editorShopifyEvent(event, this, this.open.bind(this))),
             document.addEventListener("shopify:section:deselect", event => editorShopifyEvent(event, this, this.close.bind(this)))))
    }

    init() {
        Shopify && Shopify.designMode || setTimeout(function () {
            this.open()
        }.bind(this), parseInt(this.dataset.delay) * 1e3)
    }


    open() {
        document.body.classList.add("newsletter-modal-show"), this.popup.classList.add("popup-open")
    }
    close() {
        if (this.popup.classList.add("popup-closing"), setTimeout(() => {
            this.popup.classList.remove("popup-open"), this.popup.classList.remove("popup-closing")
        }, 500), this.dataset.mode === "test") {
            this.removeCookie(this.cookieName);
            return
        }
    }
    hide() {
        this.popup.classList.add("popup-closing"), setTimeout(() => {
            this.popup.classList.remove("popup-open"), this.popup.classList.remove("popup-closing")
        }, 500), this.setCookie(this.cookieName, this.dataset.expire)
    }
    getCookie(name) {
        const match = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
        return match ? match[2] : null
    }
    setCookie(name, expiry) {
        document.cookie = `${name}=true; max-age=${expiry * 24 * 60 * 60}; path=/`
    }
    removeCookie(name) {
        document.cookie = `${name}=; max-age=0`
    }

}
customElements.define("newsletter-modal", NewsletterModal);




    if (!customElements.get("collapsible-mobilecontent")) {
                class collapsibleMobileContent extends HTMLElement {
                    constructor() {
                        super();
                        this.detailsList = Array.from(this.querySelectorAll('details'));
                        this.isMobile = window.innerWidth < 769;

                        this.boundHandleResize = this.handleResize.bind(this);
                        this.boundToggleHandlers = new Map(); // Map of details => handler functions

                        this.init();

                        window.addEventListener('resize', this.boundHandleResize);
                    }

                    init() {
                        if (this.isMobile) {
                            this.enableAccordion();
                        } else {
                            this.disableAccordion();
                        }
                    }

                    handleResize() {
                        const nowMobile = window.innerWidth < 768;
                        if (nowMobile !== this.isMobile) {
                            this.isMobile = nowMobile;
                            if (this.isMobile) {
                                this.enableAccordion();
                            } else {
                                this.disableAccordion();
                            }
                        }
                    }

                    enableAccordion() {
                        this.detailsList.forEach(details => {
                            const toggle = details.querySelector('summary');
                            const panel = toggle.nextElementSibling;

                            // Reset styles and state
                            panel.style.height = '0';
                            details.open = false;
                            details.classList.remove('is-closing');

                            // Create and bind handler for this details
                            const handler = (evt) => {
                                evt.preventDefault();

                                if (!details.open) {
                                    // open with animation
                                    panel.style.height = '0';
                                    details.open = true;
                                    requestAnimationFrame(() => {
                                        panel.style.height = `${panel.scrollHeight}px`;
                                    });
                                } else {
                                    // close with animation
                                    panel.style.height = `${panel.scrollHeight}px`;
                                    details.classList.add('is-closing');
                                    setTimeout(() => {
                                        panel.style.height = '0';
                                    }, 10);
                                }
                            };

                            if (!this.boundToggleHandlers.has(details)) {
                                toggle.addEventListener('click', handler);
                                this.boundToggleHandlers.set(details, handler);
                                panel.addEventListener('transitionend', (evt) => {
                                    if (evt.target !== panel) return;
                                    if (details.classList.contains('is-closing')) {
                                        details.classList.remove('is-closing');
                                        details.open = false;
                                        panel.style.height = '';
                                    }
                                });
                            }
                        });
                    }

                    disableAccordion() {
                        this.detailsList.forEach(details => {
                            const toggle = details.querySelector('summary');
                            const panel = toggle.nextElementSibling;

                            const handler = this.boundToggleHandlers.get(details);
                            if (handler) {
                                toggle.removeEventListener('click', handler);
                                this.boundToggleHandlers.delete(details);
                            }

                            panel.style.height = '';
                            details.classList.remove('is-closing');
                            details.open = true;
                        });
                    }

                    disconnectedCallback() {
                        window.removeEventListener('resize', this.boundHandleResize);
                        this.detailsList.forEach(details => {
                            const toggle = details.querySelector('summary');
                            const handler = this.boundToggleHandlers.get(details);
                            if (handler) {
                                toggle.removeEventListener('click', handler);
                            }
                        });
                        this.boundToggleHandlers.clear();
                    }
                }
          customElements.define('collapsible-mobilecontent', collapsibleMobileContent);
    }
